import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuard} from "./pages/auth/shared/auth.guard";

const routes: Routes = [
  {path: '', loadChildren: './pages/inicio/inicio.module#InicioModule', canActivate: [AuthGuard]},
  {path: 'auth', loadChildren: './pages/auth/auth.module#AuthModule'},
  {path: 'compras', loadChildren: './pages/compras/compras.module#ComprasModule', canActivate: [AuthGuard]},
  {path: 'vendas', loadChildren: './pages/vendas/vendas.module#VendasModule', canActivate: [AuthGuard]},
  {path: 'lancamentos', loadChildren: './pages/lancamentos/lancamentos.module#LancamentosModule', canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
